import { requestRealEstate } from '@/application/api';

export class RealEstatesClient {
  static async getExecutives() {
    const response = await requestRealEstate.get('real-estates/executives');
    return response.data || [];
  }
}
